import Vue from 'vue'
import { Notification } from 'element-ui'
import { t } from '@/i18n'

const notificationRenderer = new Vue()

/**
 * 统一程序式通知入口，业务代码不直接依赖 Element UI Notification。
 */
export function openUiNotification (options = {}) {
  const customClass = ['ui-notification', options.customClass].filter(Boolean).join(' ')
  return Notification({
    ...options,
    customClass
  })
}

/**
 * 展示终端公告通知，使用 VNode 输出文本以避免公告内容被当作 HTML 执行。
 */
export function openAnnouncementNotification ({ title, message, sender, time, onRead, onAction }) {
  let notification = null
  let hasRead = false

  const markAsRead = () => {
    if (hasRead) return
    hasRead = true
    if (typeof onRead === 'function') onRead()
    if (notification) notification.close()
  }

  const openAction = () => {
    markAsRead()
    if (typeof onAction === 'function') onAction()
  }

  const content = notificationRenderer.$createElement('div', { class: 'ui-announcement-notification' }, [
    notificationRenderer.$createElement('div', { class: 'ui-announcement-notification__message' }, [
      String(message || '')
    ]),
    notificationRenderer.$createElement('div', { class: 'ui-announcement-notification__meta' }, [
      t('发布人：{0} · {1}', [sender || t('管理员'), String(time || '')])
    ]),
    notificationRenderer.$createElement('div', { class: 'ui-announcement-notification__actions' }, [
      ...(typeof onAction === 'function' ? [notificationRenderer.$createElement('button', {
        class: 'ui-announcement-notification__read ui-announcement-notification__read--action',
        attrs: { type: 'button' },
        on: { click: event => { event.stopPropagation(); openAction() } }
      }, [t('日终处理')])] : []),
      notificationRenderer.$createElement('button', {
        class: 'ui-announcement-notification__read',
        attrs: { type: 'button' },
        on: {
          click: event => {
            event.stopPropagation()
            markAsRead()
          }
        }
      }, [t('标记已读')])
    ])
  ])

  notification = openUiNotification({
    title: title || t('公告通知'),
    message: content,
    duration: 0,
    showClose: true,
    customClass: 'ui-announcement-notification-shell',
    onClick: typeof onAction === 'function' ? openAction : markAsRead
  })

  return notification
}

/** 订单提醒复用站内公告浮层结构，点击查看才切换订单页。 */
export function openOrderNotification ({ order, onView, type = 'pending' }) {
  let notification = null
  const viewOrder = () => {
    if (notification) notification.close()
    if (typeof onView === 'function') onView()
  }
  const details = [
    [t('订单号'), order && order.order_sn],
    [t('收货站点'), order && order.receive_site_name],
    [t('订单总价'), order && order.total_price !== null && order.total_price !== undefined && order.total_price !== '' ? `${order.total_price} ${t('元')}` : null]
  ].filter(([, value]) => value !== null && value !== undefined && value !== '')
  const content = notificationRenderer.$createElement('div', { class: 'ui-announcement-notification' }, [
    notificationRenderer.$createElement('div', { class: 'ui-announcement-notification__message' }, [t(type === 'refund' ? '有订单申请退款' : '有新订单待处理')]),
    ...details.map(([label, value]) => notificationRenderer.$createElement('div', { class: 'ui-order-notification__detail' }, [
      notificationRenderer.$createElement('span', { class: 'ui-order-notification__label' }, [label]),
      notificationRenderer.$createElement('span', { class: 'ui-order-notification__value', attrs: { title: String(value) } }, [String(value)])
    ])),
    notificationRenderer.$createElement('div', { class: 'ui-announcement-notification__actions' }, [
      notificationRenderer.$createElement('button', {
        class: 'ui-announcement-notification__read',
        attrs: { type: 'button' },
        on: { click: event => { event.stopPropagation(); viewOrder() } }
      }, [t('查看订单')])
    ])
  ])
  notification = openUiNotification({
    title: t(type === 'refund' ? '退款申请' : '新订单'),
    message: content,
    duration: 0,
    showClose: true,
    customClass: 'ui-announcement-notification-shell ui-order-notification-shell',
    onClick: viewOrder
  })
  return notification
}
